import React, { lazy, Suspense } from 'react'
import Text from './Text'
import * as loader from './../../assets/animations/loader.json'

const Lottie = lazy(() => import('lottie-react'))

const Loader = ({ title = '' }) => {
  const loadingMessage =
    title ||
    'Loading... Why did the doctor carry a red pen? In case they needed to draw blood.'

  return (
    <div className="fixed top-0 left-0 h-screen w-screen z-[1000] bg-WHITE flex justify-center items-center px-6">
      <div>
        <Suspense fallback={<div>Loading animation...</div>}>
          <Lottie
            animationData={loader}
            autoplay
            loop
            className="h-full w-full"
          />
        </Suspense>
        <div className="max-w-[314px] lg:max-w-md mx-auto">
          <Text
            tag="p"
            variant="title"
            size="small"
            className="text-text-quartenary"
            textalign="center"
          >
            {loadingMessage}
          </Text>
        </div>
      </div>
    </div>
  )
}

export default Loader
